import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Dialog, Badge } from 'element-react'
import AppRoutes from '../../../routes/appRoutes'

// Icon Images
let newEquipment = {
    backgroundImage: 'url(/img/nav-svgs/Used_Equipment_New.svg)',
}

let usedEquipment = {
    backgroundImage: 'url(/img/nav-svgs/Used_Equipment_Used.svg)',
}

const EquipmentFinderDialog = props => {
    let { cancel, show } = props

    // This check fixes an issue with the dialog on IE11.
    return show ? (
        <Dialog
            className="dashboard-dialog"
            size="large"
            title=" "
            visible={true}
            onCancel={cancel}
        >
            <Dialog.Body>
                <div className="row max400">
                    <div className="columns small-12">
                        {/* Dashboard Icons ~~~~~~~~~~~~~~~~~~ */}
                        <div className="dashboard-icons">
                            <div className="row small-up-2">
                                {/* Request Equipment */}
                                <div className="columns">
                                    <Link
                                        to={{
                                            pathname: AppRoutes.newEquipmentRequest(),
                                        }}
                                        className="link"
                                    >
                                        <span
                                            className="background-image"
                                            style={newEquipment}
                                        />
                                        <h6>New Equipment</h6>
                                    </Link>
                                </div>

                                <div className="columns">
                                    <Link
                                        to={{
                                            pathname: AppRoutes.usedEquipmentRequest(),
                                        }}
                                        className="link"
                                    >
                                        <Badge
                                            className="dashboard"
                                            value={'NEW'}
                                        >
                                            <span
                                                className="background-image"
                                                style={usedEquipment}
                                            />
                                        </Badge>
                                        <h6>Used Equipment</h6>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog.Body>
        </Dialog>
    ) : null
}

EquipmentFinderDialog.propTypes = {
    cancel: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
}

export default EquipmentFinderDialog
